// @ts-nocheck
import { TypeOfArray } from "@toolkit/Framework/Types/Common";
import isArray from "lodash/isArray";

type ToUndefinedType<T> = T extends undefined ? T : never; // Use "undefined" only if the entry type has it
type ToLiteralType<T> = T extends undefined ? never : TypeOfArray<T>; // Remove "undefined" and extract array subtypes
type ToArrayType<T> = ToLiteralType<T>[];
type GetArrayReturnType<T> = ToArrayType<T> | ToUndefinedType<T>;

function getArray<T>(value: T): GetArrayReturnType<T>;
function getArray<T, U>(value: T, transform: (value: ToLiteralType<T>, index: number) => U): U[];
function getArray<T, U>(value: T, transform?: (value: ToLiteralType<T>, index: number) => U) {
    if (typeof value === "undefined") {
        return undefined;
    }

    const array = (isArray(value) ? value : [value]) as ToArrayType<T>;

    return transform ? array.map(transform) : array;
}

export default getArray;
